import React from 'react';
import Card from '../../../../../components/Card/Card';
import './MatchSelection.css';

const MatchSelection = ({title, numberOfMatches, teams, handleMatchChange, roundType, matches = [] }) => {
  // Altid have præcis numberOfMatches matches
  // Hvis der findes matches i databasen, vis dem på deres plads (baseret på id/index)
  // Ellers brug tomme placeholders
  const displayMatches = Array.from({ length: numberOfMatches }, (_, index) => {
    const matchId = `match-${index + 1}`;
    const positionNumber = index + 1;
    
    // Find match fra database med samme id eller samme nummer i ID'et
    // Eksempel: 'match-1', 'playoff_1', 'match-1' alle matcher position 1
    const savedMatch = matches.find(m => {
      if (!m || !m.id) return false;
      // Tjek om ID'et matcher direkte
      if (m.id === matchId) return true;
      // Tjek om ID'et indeholder samme nummer (fx 'playoff_1' -> 1, 'match-1' -> 1)
      const matchNumber = m.id.match(/(\d+)/);
      if (matchNumber && parseInt(matchNumber[1]) === positionNumber) return true;
      return false;
    });
    
    // Hvis der findes en gemt match, brug den, ellers brug placeholder
    return savedMatch ? {
      id: matchId, // Brug normaliseret ID format
      home: savedMatch.home || '',
      away: savedMatch.away || '',
      winner: savedMatch.winner || '',
      homeScore: savedMatch.homeScore || 0,
      awayScore: savedMatch.awayScore || 0,
      aggregateScore: savedMatch.aggregateScore || ''
    } : {
      id: matchId,
      home: '',
      away: '',
      winner: '',
      homeScore: 0,
      awayScore: 0,
      aggregateScore: ''
    };
  });

  return ( 
    <Card className="admin-card">
      <h4>{title}</h4>
        {displayMatches.map((match, index) => (
          <div key={match.id} className="match-row">
            <div className="match-header">
              <span>Kamp {index + 1}</span>
            </div>
            <div className="match-inputs">
              <select
                value={match.home || ''}
                onChange={(e) => handleMatchChange(roundType, match.id, 'home', e.target.value)}
                className="team-select"
              >
                <option value="">Vælg hjemmehold</option>
                {teams.map((team, teamIndex) => (
                  <option key={teamIndex} value={team.name}>{team.name}</option>
                ))}
              </select>
              <span className="vs">vs</span>
              <select
                value={match.away || ''}
                onChange={(e) => handleMatchChange(roundType, match.id, 'away', e.target.value)}
                className="team-select"
              >
                <option value="">Vælg udehold</option>
                {teams.map((team, teamIndex) => (
                  <option key={teamIndex} value={team.name}>{team.name}</option>
                ))}
              </select>
              <select
                value={match.winner || ''}
                onChange={(e) => handleMatchChange(roundType, match.id, 'winner', e.target.value)}
                className="winner-select"
                disabled={!match.home || !match.away}
              >
                <option value="">Vælg vinder</option>
                {match.home && <option value={match.home}>{match.home}</option>}
                {match.away && <option value={match.away}>{match.away}</option>}
              </select>
            </div>
          </div>
        ))}
    </Card>
  );
};

export default MatchSelection;
